import { render, staticRenderFns } from "./BalanceChart.vue?vue&type=template&id=c912587e&"
import script from "./BalanceChart.vue?vue&type=script&lang=js&"
export * from "./BalanceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports